import type { ReduxStore } from 'config/reduxStore';

let reduxStore: ReduxStore;

export const setStore = (store: ReduxStore) => {
  reduxStore = store;
};

export const getStore = () => reduxStore;
